import { CheckListModel } from './../../app/models/CheckListModel';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';
import { AnexoModel } from '../../app/models/anexoModel';
import { Events } from 'ionic-angular'
import { AlertProvider } from '../../providers/alert/alert';
import { SpinnerProvider } from '../../providers/spinner/spinner';



@Injectable()
export class ChecklistProvider {


  constructor(
    private spinnerSrv: SpinnerProvider,
    private httpSrv: HttpProvider,
    public events : Events,
    public alertSrv: AlertProvider,
    ) {

    this.events.subscribe('checklist:finalizouAdicional', (dados) => {
      if(dados.itensSelecionados){
        dados.itensSelecionados.itensChecklist;
  
        // Retorna os itens com valor zerado para adicionar ao cardápio
        
        this.postAdicional('montaPrecificar', dados).then(result => {   
          
          let itensMarcados = result.filter(function(x){
            x.item =  x.tipo.split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
            return x;
          });
          
          if(itensMarcados.length > 0){
            this.adicionaItensAoOrcamento(dados.atendimento.id, itensMarcados).then( x=> {
              this.events.publish('atendimento:atualizado', dados)
            });
          } else {
            this.spinnerSrv.Hide()
          }
  
        });
      }
    });

  }
  async adicionaItensAoOrcamento(idAtendimento, itens){
    var url = 'adicionaItensAoOrcamento';
    var body = {
      "idAtendimento": idAtendimento,
      "itens": itens
    };

    try {
      let ResultConn = await this.httpSrv.postApi(url, body, 0, 1);
      if (ResultConn.success) {
        return ResultConn.data.atendimento;
      } else {
        this.alertSrv.alert("OPS...", "Aconteceu algo inesperado ao salvar alteração do orçamento.");
        return false;
      }
    } catch (error) {
      console.log('Problema ao tentar alterar orçamento.', error);
    }
  }
    
  async getQuestionarioEntrada(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.getApi('v1/questionario/' + _questionario + '/' +_modelo, 1, 'Carregando CheckLists');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o questionario do checklist', error);
    }
  }

  async postQuestionarioCheckList(_api: string, _questionario: number, _checklist: CheckListModel): Promise<Array<any>> {
    try {
        let ResultConn = await this.httpSrv.postApi("v1/" + _api + "/"+ _questionario + "/cadastro", _checklist, 0, 1);
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }


  async putQuestionarioCheckList(_api: string, _questionario: number, _checklist: CheckListModel): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.putChecklist(_api + "/" + _questionario + "/" + _checklist.codCheckList, _checklist, 0, 1);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async postQuestionarioAnexo(_api: string, _questionario: number, codCheckList: number, _model: AnexoModel, mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + _questionario + "/anexo_2/" + codCheckList, _model, 0, 1, mensagem);
      console.log("ResultConn ", JSON.stringify(ResultConn))
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o anexo checklist', error);
    }
  }

  async post(url : string, data : any, loading: number = 0, mensagem: string = null){
    try {
      let ResultConn = await this.httpSrv.postApi(url, data, loading, 1, mensagem);
      if (ResultConn.success) {
        return ResultConn.data;
      }else{
        return false;
      }
    } catch (error) {
      console.log('Problema ao enviar o checklist', error);
    }
  }

  async postAdicional(url : string, data : any){
    try {
      let ResultConn = await this.httpSrv.postApi('v1/'+url, data, 0, 1);
      if (ResultConn.success) {
        return ResultConn.data;
      }else{
        return false;
      }
    } catch (error) {
      console.log('Problema ao enviar o checklist', error);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/checklist/checklist.ts